import Vue from 'vue'
import { Form, Button, Input, Select, DatePicker, Radio, Modal, message } from 'ant-design-vue'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import 'moment/locale/zh-cn'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
